import { request } from './base';
import * as models from '../../models'; 
import utils from '../../utils'; 
import { AD_Invoice_Selector } from '../../models/enums'; 

function getEnumNameByValue(value:string): string | undefined {
    return Object.entries(AD_Invoice_Selector).find(([_, enumValue]) => enumValue === value)?.[0]; 
}

export const getAdjusterDashboard = async (id: number, invoiceSelector: AD_Invoice_Selector) => {    
    var param = getEnumNameByValue(invoiceSelector); 
    var qStr = utils.helpers.encodeQueryString({invoiceSelector: param});

    const response = await request ({
        method: 'GET', 
        url: `/dashboards/adjuster/${id}?${qStr}`
    }); 
    return response; 
}; 

export const getAdjusterInvoices = async (id: number, invoiceSelector: AD_Invoice_Selector) => {    
    var param = getEnumNameByValue(invoiceSelector); 
    var qStr = utils.helpers.encodeQueryString({invoiceSelector: param});

    const response = await request ({
        method: 'GET', 
        url: `/dashboards/adjuster/${id}/export?${qStr}`,
        responseType: 'blob',
    }); 
    if (response.isSuccess) {            
        try {
            utils.filehelpers.downloadFile(response);

        } catch (err) {
            return {
                error: err,
                };
        }     
    return true; 
    }
    else {
        console.log(response); 
    }
}; 

export const getAdminDashboard = async () => {    
    const response = await request ({
        method: 'GET', 
        url: `/dashboards/admin`
    }); 
    return response; 
}; 

export const getOpenClaimsByCompany = async () => {
    const response = await request ({
        method: 'GET',
        url: `/claims/openClaimsByCompany`
    }); 
    return response; 
};

export const getMonthlyClaimActivity = async (monthsBack: number, months: number) => {
    var qStr = utils.helpers.encodeQueryString({monthsBack, months});

    const response = await request ({
        method: 'GET',
        url: `/claims/monthlyClaimActivity?${qStr}`, 
    }); 
    return response; 
}; 

export const getPayrolLDashboard = async () => {
    const response = await request ({
        method: 'GET',
        url: `/dashboards/payroll`
    }); 
    return response; 
};